import { PlAN_TYPES } from '../../../constants/individualPortal/customGrouping/customGrouping.constants';
import { APP_TYPES } from '../../../constants/individualPortal/dashboard/dashboardModelTypes';
import { IConditions } from './sm.types';

const conditions: IConditions = {
    areAllIneligibileMembers: (_, model) => {
        const group = model.groupItem;
        return !group.memberList?.length && group.inEligibleMemberList?.length > 0;
    },
    isInsideOEPEnrollmentWindow: (_, model) => {
        return model.customGroupingData.isInsideOEEnrollmentWindow;
    },
    isSEPApplication: (_, model) => {
        return model.customGroupingData.applicationType === APP_TYPES.SEP;
    },
    isQEPApplication: (_, model) => {
        return model.customGroupingData.applicationType === APP_TYPES.QEP;
    },
    isOEApplication: (_, model) => {
        return model.customGroupingData.applicationType === APP_TYPES.OE;
    },
    isOEorQEApplication: (_, model) => {
        return (
            model.customGroupingData.applicationType === APP_TYPES.OE ||
            model.customGroupingData.applicationType === APP_TYPES.QEP
        );
    },
    isEnrollmentIdSimilartoPriorApplicationId: (_, model) => {
        return model.customGroupingData.applicationId === model.groupItem.enrollmentPriorApplicationId;
    },
    isEnrollmentIdNotEqualtoPriorApplicationId: (_, model) => {
        return model.customGroupingData.applicationId !== model.groupItem.enrollmentPriorApplicationId;
    },
    isGroupRenewal: (_, model) => {
        return model.groupItem.isRenewal;
    },
    isNoGroupRenewal: (_, model) => {
        return !model.groupItem.isRenewal;
    },
    hasUnenrolledDentalMembers: (_, model) => {
        const group = model.groupItem;
        return group.groupType === PlAN_TYPES.DENTAL && group.memberList?.some(member => !member.dentalEnrollmentId);
    },
    isHealthOrAllDentalEnrolledMembers: (_, model) => {
        const group = model.groupItem;
        return group.groupType === PlAN_TYPES.HEALTH || group.memberList?.every(member => member.dentalEnrollmentId);
    },
    isAllowedToChangePlan: (_, model) => {
        return model.customGroupingData.allowMemberLevelChangePlan;
    },
    isNotAIANMemberOrLowFPL: (_, model, config) => {
        return !(config?.anyAIANMember || model.customGroupingData.allowOnceAMonthShoppingForLowFpl);
    },
    isEnrollmentCoverageDateInThisMonth: (_, model, config) => {
        return !!(
            model.groupItem.enrollmentCreationDate &&
            (model.customGroupingData.shoppingOpenForEntireShoppingWindow ||
                !config.isEnrollmentCoverageDateWithinThisMonth)
        );
    },
    isEnrollmentCoverageDateNotInThisMonth: (_, model, config) => {
        return !(
            model.groupItem.enrollmentCreationDate &&
            (model.customGroupingData.shoppingOpenForEntireShoppingWindow ||
                !config.isEnrollmentCoverageDateWithinThisMonth)
        );
    },
    isGroupAllowedToChangePlan: (_, model, config) => {
        const { allowOnceAMonthShoppingForLowFpl, shoppingOpenForEntireShoppingWindow } = model.customGroupingData;
        const { allowChangePlan } = model.groupItem;
        return (
            allowChangePlan === 'Y' ||
            (allowChangePlan === 'N' &&
                (allowOnceAMonthShoppingForLowFpl || config.anyAIANMember) &&
                config.isEnrollmentCoverageDateWithinThisMonth !== null &&
                (!config.isEnrollmentCoverageDateWithinThisMonth || shoppingOpenForEntireShoppingWindow))
        );
    },
    defaultCondition: () => true,
};

export default conditions;
